import cx from 'classnames'
import { type ReactNode } from 'react'

import ChevronIcon from '../utility/chevron-icon'

interface ConfigurationDefinitionProps {
  number: number
  title: string
  onClose: () => void
  children: ReactNode
  className?: string
}

const ConfigurationDefinition = ({
  title,
  onClose,
  number,
  children,
  className,
}: ConfigurationDefinitionProps) => {
  return (
    <div className={cx('flex flex-col sm:h-full bg-white', className)}>
      <div
        onClick={onClose}
        className="grow-0 shrink-0 flex flex-row-reverse justify-end items-center h-[78px] py-5 px-6 select-none hover:cursor-pointer border-b border-gray-300"
      >
        <div className="flex items-center space-x-2">
          <div className="flex flex-col justify-center h-full space-y-1">
            <span>
              {number}. {title}
            </span>
          </div>
        </div>

        <ChevronIcon
          direction="left"
          className="flex-none inline-block h-[10px] mr-2"
        />
      </div>

      <div className="py-6 space-y-6 sm:overflow-y-auto"> {children}</div>
    </div>
  )
}

export default ConfigurationDefinition
